<div class="wrapper mt-[20px] flex flex-col">
  @if (initialized) {
    @if (!lineage.length) {
      <div class="mat-body-strong no-changes">
        <mat-icon>info</mat-icon>
        <span>No changes found for this daily report</span>
      </div>
    }
    <!-- List -->
    @if (lineage.length) {
      <div class="list">
        @for (line of lineage; track line) {
          <div class="list-item">
            <div class="flex items-center">
              <span class="state-comment">{{line.state?.comment || 'Status changed'}}</span>
            </div>
            <div class="flex items-center">
              @if (line.actor?.id) {
                <span class="actor-info">{{line.actor?.first_name}} {{line.actor?.last_name}} - </span>
              }
              <span class="date-info ml-1">{{formatDate(line.created_at)}}</span>
            </div>
            @if (getCommentText(line.input)) {
              <div class="quote">{{getCommentText(line.input)}}</div>
            }
          </div>
        }
      </div>
    }
    <!-- List -->
    @if (pagination.length && lineage.length) {
      <mat-paginator
        (page)="pageChanged($event)"
        [length]="pagination.length"
        [pageIndex]="pagination.pageIndex"
        [pageSize]="pagination.pageSize">
      </mat-paginator>
    }
  }

  @if (loading > 0) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
      <div class="loading-text">Loading changes...</div>
    </div>
  }

  @if (!reportId) {
    <div class="no-selection">
      <mat-icon>note</mat-icon>
      <div>Please select a daily report to view changes</div>
    </div>
  }
</div>
